export enum OptionCodeSnippet {
  cURL = 'cURL',
  OpenAI = 'OpenAI',
  Langchain = 'Langchain',
}
